import DataPanel from "../DataPanel";
import { useCallback, useEffect, useState } from "react";
import PocketSpringDetails from "./PocketSpringDetails";
import useSpringMaterialCustomerPriceApi, { convertSpringPricesToMaterialIdIndexedArray, SpringMaterialCustomerPrice } from "../../api/SpringMaterialCustomerPriceApi";
import { getPricedSpringFormattedMaterialNames, getPricedSpringFormattedMaterialsThickness, PricedSpring } from "../../api/PricedSpringApi";
import { formatCurrency } from "../../engine/PriceUtilities";
import useHttp from "../../security/Http.hook";

interface Properties {
  readonly customerId: number;
  readonly priceListId: number;
}

const columns = [
  {
    name: 'name',
    label: 'Nazwa',
    options: {}
  },
  {
    name: 'material',
    label: 'Materiał',
    options: {}
  },
  {
    name: 'thickness',
    label: 'Grubości drutu',
    options: {}
  },
  {
    name: 'width',
    label: 'Szerokość',
    options: {}
  },
  {
    name: 'length',
    label: 'Długość całkowita',
    options: {}
  },
  {
    name: 'zoneCount',
    label: 'Liczba stref',
    options: {}
  },
  {
    name: 'price',
    label: 'Cena [zł]',
    options: {}
  }
];

const PocketSpringsPanel = (properties: Properties) => {
  const http = useHttp();
  const springMaterialCustomerPriceApi = useSpringMaterialCustomerPriceApi();
  const customerId = properties.customerId;
  const priceListId = properties.priceListId;
  const [materialPrices, setMaterialPrices] = useState<SpringMaterialCustomerPrice[]>();

  const convertPocketSprings = useCallback((pricedPocketSpring: PricedSpring) => ({
    id: pricedPocketSpring.id,
    name: pricedPocketSpring.name,
    material: getPricedSpringFormattedMaterialNames(pricedPocketSpring),
    thickness: getPricedSpringFormattedMaterialsThickness(pricedPocketSpring),
    width: pricedPocketSpring.width,
    length: pricedPocketSpring.length,
    zoneCount: pricedPocketSpring.materials.length,
    price: pricedPocketSpring.price === undefined ? '?' : formatCurrency(pricedPocketSpring.price)
  }), [customerId, priceListId]);

  useEffect(() => {
    springMaterialCustomerPriceApi
      .fetchSpringMaterialCustomerPrices(customerId, priceListId)
      .then(convertSpringPricesToMaterialIdIndexedArray)
      .then(setMaterialPrices);
  }, [customerId, priceListId]);

  return <DataPanel
    title='Sprężyny kieszeniowe'
    resource={ `customers/${customerId}/price-lists/${priceListId}/pocket-springs` }
    columns={ columns }
    deleteRequiresConfirmation
    selectableRows='multiple'
    tableSearchEnabled
    renderDetails={(detailsProps) => <PocketSpringDetails { ...{
      ...detailsProps,
      customerId,
      priceListId,
      materialPrices: materialPrices || [] }} />}
    convert={ convertPocketSprings }
    onDelete={ resourceId => http.delete(`/api/customers/${customerId}/pocket-springs/${resourceId}`) }
  />
};
export default PocketSpringsPanel;